<template>
    <div class="container">
        <div class="contact">
            <span>CONTACT</span>
            <p>Feel free to get in touch. You can email me at: <a href="mailto:allannelly690@gmail.com">allannelly690@gmail.com</a></p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ContactsComponent'
    }
</script>

<style scoped>
    .container {
        margin-top: -680px;
        margin-left: 450px;
        background-color: white;
        height: 150px;
        width: 800px;
        border-radius: 25px;
    }
    span {
        display: block;
        text-align: left;
        padding: 30px;
        font-weight: bold;
        border-bottom: solid 1px rgba(160,160,160,0.65);
    }

</style>
